import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatMenuModule } from "@angular/material/menu";
import { MatTabsModule } from "@angular/material/tabs";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { RouterModule } from "@angular/router";
import { CalendarModule } from "angular-calendar";
import { NouisliderModule } from "ng2-nouislider";
import { ModalProcessingModule } from "src/app/shared/modal-processing/modal-processing.module";
import { ExponerInformacionComponent } from "../components/cambio-estado-civil/exponer-informacion/exponer-informacion.component";
import { SeleccionarNuevoEstadoComponent } from "../components/cambio-estado-civil/seleccionar-nuevo-estado/seleccionar-nuevo-estado.component";
import { AnswerPageComponent } from "../components/common/answer-page/answer-page.component";
import { DialogComponent } from "../components/common/dialog/dialog.component";
import { DialogoConfirmacionComponent } from "../components/common/dialogo-confirmacion/dialogo-confirmacion.component";
import { BuildFormModuleModule } from "../components/common/form-dynamic/build-form-request.module";
import { ResponseComponent } from "../components/common/response/response.component";
import { FormularioInformacionBeneficiarioComponent } from "../components/individual-afiliate-beneficiary/individual-afiliate-beneficiary-form/new-beneficiary-form/componentes/formulario-informacion-beneficiario/formulario-informacion-beneficiario.component";
import { DebounceClickEventDirective } from "../core/directives/debounce-click-event.directive";
import { DebounceClickGeneralDirective } from "../core/directives/debounce-click-general.directive";
import { DebounceClickDirective } from "../core/directives/debounce-click.directive";
import { DiscapacidadStringPipe } from "../core/pipes/discapacidad/discapacidad-string.pipe";
import { FormatDocumentTypePipe } from "../core/pipes/format-documant-type/format-document-type.pipe";
import { FormatNumberCreditPipe } from "../core/pipes/number-credit/format-number-credit.pipe";
import { StateRequestNumberToStringPipe } from "../core/pipes/request/state-request-number-to-string.pipe";
import { TypeRequestNumberToStringPipe } from "../core/pipes/request/type-request-number-to-string.pipe";
import { AccessibilityItemsComponent } from "./accessibility-items/accessibility-items.component";
import { CalendarHeaderComponent } from "./calendar-header/calendar-header.component";
import { CalendarComponent } from "./calendar/calendar.component";
import { DateFormatComponent } from "./date-format/date-format.component";
import { DonutChartComponent } from "./donut-chart/donut-chart.component";
import { FormAffiliationSummaryComponent } from "./form-affiliation-summary/form-affiliation-summary.component";
import { FormErrorsModule } from "./form-errors/form-errors.module";
import { FormResponseComponent } from "./form-response/form-response.component";
import { HeaderCardComponent } from "./header-card/header-card.component";
import { ModalVariadoComponent } from "./modal-variado/modal-variado.component";
import { ModalComponent } from "./modal/modal.component";
import { NavDashComponent } from "./nav-dash/nav-dash.component";
import { NavUserComponent } from "./nav-user/nav-user.component";
import { NotifyComponent } from "./notify/notify.component";
import { NouisliderComponent } from "./nouislider/nouislider.component";
import { SampleMaterialIconComponent } from "./sample-material-icon/sample-material-icon.component";
import { TitleSectionComponent } from "./title-section/title-section.component";
import { ValidateUserComponent } from "./validate-user/validate-user.component";
import { VerticalShortcutsComponent } from "./vertical-shortcuts/vertical-shortcuts.component";

export const MY_NATIVE_FORMATS = {
  fullPickerInput: { day: "numeric", month: "numeric", year: "numeric" },
  datePickerInput: { day: "numeric", month: "numeric", year: "numeric" },
  timePickerInput: { hour: "numeric", minute: "numeric" },
  monthYearLabel: { year: "numeric", month: "short" },
  dateA11yLabel: { year: "numeric", month: "numeric", day: "numeric" },
  monthYearA11yLabel: { year: "numeric", month: "numeric" },
};

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    CalendarModule,
    FormsModule,
    ReactiveFormsModule,
    NouisliderModule,
    MatProgressBarModule,
    MatMenuModule,
    MatDialogModule,
    MatTabsModule,
    MatExpansionModule,
    MatInputModule,
    MatNativeDateModule,
    MatDatepickerModule,
    BuildFormModuleModule,
    FormErrorsModule,
    ModalProcessingModule
  ],
  declarations: [
    NavUserComponent,
    SampleMaterialIconComponent,
    NavDashComponent,
    HeaderCardComponent,
    CalendarComponent,
    CalendarHeaderComponent,
    ValidateUserComponent,
    FormAffiliationSummaryComponent,
    TitleSectionComponent,
    DebounceClickDirective,
    VerticalShortcutsComponent,
    DebounceClickEventDirective,
    DebounceClickGeneralDirective,
    FormResponseComponent,
    DateFormatComponent,
    NouisliderComponent,
    DonutChartComponent,
    AccessibilityItemsComponent,
    NotifyComponent,
    FormatDocumentTypePipe,
    FormatNumberCreditPipe,
    ModalComponent,
    SampleMaterialIconComponent,
    ModalComponent,
    NotifyComponent,
    FormatDocumentTypePipe,
    DialogComponent,
    AnswerPageComponent,
    ResponseComponent,
    DialogoConfirmacionComponent,
    TypeRequestNumberToStringPipe,
    StateRequestNumberToStringPipe,
    DiscapacidadStringPipe,
    FormularioInformacionBeneficiarioComponent,
    ExponerInformacionComponent,
    ModalVariadoComponent,
  ],
  exports: [
    FormsModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatTabsModule,
    MatExpansionModule,
    BuildFormModuleModule,
    NavUserComponent,
    NavDashComponent,
    HeaderCardComponent,
    CalendarComponent,
    CalendarHeaderComponent,
    ValidateUserComponent,
    FormErrorsModule,
    FormAffiliationSummaryComponent,
    TitleSectionComponent,
    DebounceClickDirective,
    VerticalShortcutsComponent,
    DebounceClickEventDirective,
    DebounceClickGeneralDirective,
    DateFormatComponent,
    NouisliderComponent,
    DonutChartComponent,
    AccessibilityItemsComponent,
    NotifyComponent,
    FormatDocumentTypePipe,
    FormatNumberCreditPipe,
    ModalProcessingModule,
    ModalComponent,
    SampleMaterialIconComponent,
    ModalComponent,
    SampleMaterialIconComponent,
    NotifyComponent,
    FormatDocumentTypePipe,
    DialogComponent,
    AnswerPageComponent,
    DialogoConfirmacionComponent,
    ResponseComponent,
    TypeRequestNumberToStringPipe,
    StateRequestNumberToStringPipe,
    FormularioInformacionBeneficiarioComponent,
    DiscapacidadStringPipe,
    ExponerInformacionComponent,
    ModalVariadoComponent,
    MatInputModule,
    MatNativeDateModule,
    MatDatepickerModule
  ],
  entryComponents: [
    DialogComponent,
    DialogoConfirmacionComponent,
    ModalVariadoComponent,
  ],
  providers: [
    SeleccionarNuevoEstadoComponent,
    FormatDocumentTypePipe,
    DiscapacidadStringPipe,
    TypeRequestNumberToStringPipe,
    StateRequestNumberToStringPipe
  ]
})
export class SharedModule {}
